import styled from "styled-components";

export const UserMenuWrapperDefaultBox = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
  padding-bottom: env(safe-area-inset-bottom, 0);

  &:hover {
    overflow-y: auto;
  }
`